import formatAmount from '@modules/calculator/utils/formatAmount';
import roundStringValue, { FEE_RATE_PRECISION } from '@modules/calculator/utils/roundStringValue';
const getDemoExampleText = (t, loanAmount, period, data) => t('financing.demo_calculator_example_text_dynamic', {
    amount: formatAmount(loanAmount),
    period,
    annualInterestRate: roundStringValue(data.annualInterestRate),
    administrationFeeRate: roundStringValue(data.administrationFeeRate, FEE_RATE_PRECISION),
    apr: roundStringValue(data.annualPercentageRate),
    monthlyPayment: formatAmount(Number(data.monthlyPaymentAmount)),
    totalRepayment: formatAmount(Number(data.totalRepaymentAmount)),
});
export default getDemoExampleText;
